import { useState, useRef } from "react";
import { C } from '../constants';

export default function InfoTip({ text }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  return (
    <span ref={ref} style={{ position: "relative", display: "inline-flex", cursor: "help", flexShrink: 0 }}
      onMouseEnter={() => {
        const r = ref.current?.getBoundingClientRect();
        if (r) setPos({ x: Math.min(r.left, window.innerWidth - 280), y: r.bottom + 6 });
        setShow(true);
      }}
      onMouseLeave={() => setShow(false)}>
      <span style={{ fontSize: 10, color: C.text4, background: C.bg3, borderRadius: "50%",
        width: 15, height: 15, display: "inline-flex", alignItems: "center", justifyContent: "center",
        fontWeight: 700, userSelect: "none", border: `1px solid ${C.border}` }}>i</span>
      {show && (
        <div style={{ position: "fixed", left: pos.x, top: pos.y, zIndex: 9999,
          background: "#1e2d4a", border: `1px solid ${C.border}`,
          borderRadius: 10, padding: "10px 14px", maxWidth: 280, fontSize: 12,
          color: C.text2, lineHeight: 1.7, boxShadow: "0 8px 32px rgba(0,0,0,.6)",
          pointerEvents: "none", whiteSpace: "pre-wrap" }}>
          {text}
        </div>
      )}
    </span>
  );
}
